import React, { useState, useEffect, useMemo } from "react";
import { useHistory, useParams, Switch } from "react-router-dom";
import { Box, Card, Stack, Tab, Tabs } from '@curves/ui-base';

import { CyclePurchaseDetailMain, CyclePurchaseDetailHistory, CyclePurchaseDetailFuture, CyclePurchaseDetailPayment } from "@Local/CyclePurchase/Detail/Tabs";
import { CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL, CYCLE_PURCHASE_DETAIL_HISTORY_ROUTER_URL, CYCLE_PURCHASE_DETAIL_FUTURE_ROUTER_URL, CYCLE_PURCHASE_DETAIL_PAYMENT_ROUTER_URL } from "@Router/routerPath";
import { PrivateRoute } from "@Components/";
const CyclePurchaseDetailTabs = props => {
	const { detailData } = props;
	const history = useHistory();
	const { cycleOrderID, tab } = useParams();
	const [cyclePurchaseDetailType, setCyclePurchaseDetailType] = useState(tab);
	const tabs = useMemo(
		() => {
			return [
				{ key: "main", label: "訂單主檔", value: 1 },
				{ key: "history", label: "訂單歷史", value: 2 },
				{
					key: "future",
					label: (
						<Box className="flex">
							<Box className="tab-label">預計變更</Box>
							<Box className={"tab-label-qty"}>{detailData?.effectionQuantity}</Box>
						</Box>
					),
					value: 3,
				},
				{ key: "payment", label: "循環訂單收費明細", value: 4 },
			];
		},
		// eslint-disable-next-line
		[detailData]
	);
	const handleChangeTabs = (_, val) => {
		const tabMap = { 1: "main", 2: "history", 3: "future", 4: "payment" };
		const tabName = tabMap[val];
		if (tabName === "main") {
			history.push(CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL(cycleOrderID));
		} else if (tabName === "history") {
			history.push(CYCLE_PURCHASE_DETAIL_HISTORY_ROUTER_URL(cycleOrderID));
		} else if (tabName === "future") {
			history.push(CYCLE_PURCHASE_DETAIL_FUTURE_ROUTER_URL(cycleOrderID));
		} else if (tabName === "payment") {
			history.push(CYCLE_PURCHASE_DETAIL_PAYMENT_ROUTER_URL(cycleOrderID));
		}
	};
	useEffect(
		() => {
			const tabMap = { main: 1, history: 2, future: 3, payment: 4 };
			const newTabValue = tabMap[tab] || 1;
			setCyclePurchaseDetailType(newTabValue);
		},
		// eslint-disable-next-line
		[tab]
	);
	return (
		<Box>
			<Stack justifyContent="space-between" alignItems="center">
				<Tabs value={cyclePurchaseDetailType} onChange={handleChangeTabs}>
					{tabs.map(t => (
						<Tab key={t.value} className="py-3" label={t.label} value={t.value}></Tab>
					))}
				</Tabs>
			</Stack>
			<Card>
				<Switch>
					<PrivateRoute path={CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL(cycleOrderID)} as={() => <CyclePurchaseDetailMain detailData={detailData} />} exact />
					<PrivateRoute path={CYCLE_PURCHASE_DETAIL_HISTORY_ROUTER_URL(cycleOrderID)} as={() => <CyclePurchaseDetailHistory memberID={detailData?.memberID} cycleOrderID={detailData?.cycleOrderID} />} exact />
					<PrivateRoute path={CYCLE_PURCHASE_DETAIL_FUTURE_ROUTER_URL(cycleOrderID)} as={() => <CyclePurchaseDetailFuture memberID={detailData?.memberID} cycleOrderID={detailData?.cycleOrderID} clubName={detailData?.clubName} />} exact />
					<PrivateRoute path={CYCLE_PURCHASE_DETAIL_PAYMENT_ROUTER_URL(cycleOrderID)} as={() => <CyclePurchaseDetailPayment memberID={detailData?.memberID} cycleOrderID={detailData?.cycleOrderID} />} exact />
				</Switch>
			</Card>
		</Box>
	);
};
export default CyclePurchaseDetailTabs;
